module.exports = __webpack_public_path__ + "img/ch47.40ce0711.jpg";